import { __assign } from "tslib";
export function deepMapKeys(obj, mapFunction) {
    return Object.keys(obj).reduce(function (acc, key) {
        var _a;
        var value = obj[key];
        if (isObject(value)) {
            value = deepMapKeys(value, mapFunction);
        }
        var newKey = mapFunction(key, value);
        return __assign(__assign({}, acc), (_a = {}, _a[newKey] = value, _a));
    }, {});
}
function isObject(val) {
    return val !== null && typeof val === 'object' && !Array.isArray(val);
}
//# sourceMappingURL=object.js.map